import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';


export default function NavbarMenu() {
    return (
        <Navbar collapseOnSelect expand='lg'  variant='dark' className='mb-3 navbar-glass'>
            <Container>
                <Navbar.Toggle aria-controls='responsive-navbar-nav' />
                <Navbar.Collapse id='responsive-navbar-nav'>
                    <Nav className='me-auto'>
                        <Nav.Link as={Link} to='/mybio'>Home</Nav.Link>
                        <Nav.Link as={Link} to='/Certifications'>Certifications</Nav.Link>
                        <Nav.Link as={Link} to='/CTFs'>CTFs</Nav.Link>
                        <Nav.Link as={Link} to='/Extras'>Extras</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
